import { render, staticRenderFns } from "./YearGroupDetail.vue?vue&type=template&id=4dc6fee2&scoped=true"
import script from "./YearGroupDetail.vue?vue&type=script&lang=js"
export * from "./YearGroupDetail.vue?vue&type=script&lang=js"
import style0 from "./YearGroupDetail.vue?vue&type=style&index=0&id=4dc6fee2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc6fee2",
  null
  
)

export default component.exports